import { render } from "./HeaderIconButton.vue?vue&type=template&id=9708f2e0"
import script from "./HeaderIconButton.vue?vue&type=script&lang=js"
export * from "./HeaderIconButton.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./HeaderIconButton.vue?vue&type=style&index=0&id=9708f2e0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script